import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import lunr from 'lunr'

const BlogSearchIndex = (WrappedComponent) => {
  const BlogSearchIndexComponent = (props) => {
    const [loading, setLoading] = useState(false)
    const [blogIndex, setBlogIndex] = useState(null)

    const builder = new lunr.Builder()

    const data = useStaticQuery(graphql`
      query SearchIndexPage {
        allPrismicBlogPost {
          nodes {
            data {
              author {
                document {
                  ... on PrismicAuthor {
                    id
                    data {
                      author_name {
                        text
                        html
                      }
                      author_image {
                        url
                      }
                    }
                    uid
                  }
                }
              }
              categories {
                category {
                  uid
                }
              }
              excerpt {
                html
                text
              }
              featured_image {
                url
              }
              title {
                html
                text
              }
              timestamp(formatString: "MMM D, yyyy")
            }
            tags
            uid
            id
          }
        }
      }
    `)

    const { allPrismicBlogPost } = data
    const { nodes } = allPrismicBlogPost

    // START OF LUNR INDEXING

    useEffect(() => {
      if (!blogIndex && allPrismicBlogPost) {
        setLoading(true)
        lunr(() => {
          builder.ref('uid')
          builder.field('title', { boost: 10 })
          builder.field('tags', { boost: 8 })
          builder.field('author', { boost: 7 })
          // builder.field('body', { boost: 5 })
          builder.field('excerpt', { boost: 5 })
          nodes.forEach(function (node) {
            builder.add(
              {
                uid: node.uid,
                title: node.data.title.text,
                excerpt: node.data.excerpt.text,
                tags: node.tags ? node.tags.join() : '',
                // body: node.data.body[0].primary?.wysiwyg?.text,
                author: node.data.author?.document?.data?.author_name?.text
              },
              builder
            )
          })
        })
        const index = builder.build()
        setLoading(false)
        setBlogIndex(index)
      }
    }, [allPrismicBlogPost, blogIndex])

    return (
      <WrappedComponent {...props} blogPosts={allPrismicBlogPost} blogIndex={blogIndex} blogIndexLoading={loading} />
    )
  }
  return BlogSearchIndexComponent
}

export default BlogSearchIndex
